module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_france.842ff168.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_france.png
// module id = 1241
// module chunks = 16